import TomSelect from "tom-select";

export function selectedNItemsTomSelectPlugin(
    this: TomSelect,
    settings?: {
        visibleCount?: number,
        customCounterTemplate?: (count: number) => string,
    },
): void {
    const visibleCount = settings?.visibleCount ?? 1;
    let counterDivElement: HTMLElement;

    const itemCount = (): void => {
        if (this.items.length < visibleCount) {
            if (counterDivElement.parentNode) {
                counterDivElement.parentNode.removeChild(counterDivElement);
            }
        }
        if (this.items.length === visibleCount) {
            if (counterDivElement.parentNode) {
                counterDivElement.parentNode.removeChild(counterDivElement);
            }

            this.control.querySelectorAll("[data-ts-item]")
                .forEach((element: Element) => {
                    element.classList.remove("d-none");
                });
        }
        if (this.items.length > visibleCount) {
            let i = 1;
            this.control.querySelectorAll("[data-ts-item]")
                .forEach((element: Element) => {
                    if (i > visibleCount) {
                        element.classList.add("d-none");
                    } else {
                        element.classList.remove("d-none");
                    }
                    i++;
                });

            counterDivElement.innerText = `+${this.items.length - visibleCount}` ?? "";
            this.control.append(counterDivElement);
        }
    };

    this.on("initialize", () => {
        counterDivElement = document.createElement("div");
        counterDivElement.className = "ts-n-items";
        itemCount();
    });

    this.on("item_remove", itemCount);
    this.on("item_add", itemCount);
}
